import applyAddonConfig from 'uniba-volto-jwtsession/config/config.js';

const applyConfig = (config) => {
  return applyAddonConfig(config);
};

export default applyConfig;
